<template>
  <ContainerBasic container-type="CONTENT">
    <div
      class="min-h-[100px] flex flex-col md:flex-row justify-center items-center"
    >
      <div class="min-w-[100px] h-inherit relative">
        <img src="@/assets/images/cme-points-circle.svg" class="z-[-10]" />
        <div
          class="top-[50%] left-[50%] z-10 text-white flex flex-col absolute translate-x-[-50%] translate-y-[-50%]"
        >
          <p class="text-3xl text-center font-deco">
            {{ pageData.event.cmePoints }}
          </p>
          <p class="text-xs leading-[9px]">CME</p>
        </div>
      </div>
      <div class="flex flex-col text-center pt-md px-md md:pt-0 md:text-left">
        <h2 class="text-vdv-base font-josefin">
          {{ t('event.cmePointsHeadline') }}
        </h2>
        <span>
          {{ t('event.cmePointsText', { points: pageData.event.cmePoints }) }}
        </span>
      </div>
    </div>
  </ContainerBasic>
</template>

<script setup lang="ts">
import ContainerBasic from '@/components/components/container-basic.vue';
import type { EventPage } from '~~/src/server/transformers/page/eventPage';

const { t } = useTrans();

defineProps({
  blockData: {
    type: Object as PropType<any>,
    required: true,
    default: {} as any,
  },
});

const pageData = usePageData<EventPage>();
</script>
